import type {CanvasProductChoiceResult,ResolveCanvasProductRequest} from '@shared/canvasProductChoice';
export async function resolveCanvasProduct(request:ResolveCanvasProductRequest):Promise<CanvasProductChoiceResult>{
 const response=await fetch('/api/canvas/resolve-product',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(request)});
 const body=await response.json().catch(()=>null);
 if(!response.ok)throw new Error(body?.error||'Could not check products. Please try again.');
 if(body?.status==='resolved'&&Number.isSafeInteger(body.productId)&&body.productId>0)return body;
 if(body?.status==='choice_required'&&Array.isArray(body.candidates)&&body.candidates.every((p:any)=>Number.isSafeInteger(p.id)&&p.id>0&&typeof p.name==='string'))return body;
 throw new Error('Could not check products. Please try again.');
}
